import { useState } from 'react'

import type { ValidationStatusId } from '@app/lib/validators'

export function useValidatedState(
  initialValue: string,
  initialValidationState: ValidationStatusId,
): [
  string,
  (string) => void,
  ValidationStatusId,
  (ValidationStatusId) => void,
] {
  const [value, setValue] = useState(initialValue)
  const [validation, setValidation] = useState(initialValidationState)

  return [value, setValue, validation, setValidation]
}
